<template>
  <div class="form-container" :class="{ isMobile: isMobile }">
    <div class="auth-form">
      <h1 class="auth-title mb-6">Zapomniałeś hasło?</h1>
      <div v-if="showSuccessText" class="color-primary-purple">
        <p class="bold">
          Jeśli podany adres e-mail jest poprawny, wysłaliśmy na niego link
          umożliwiający zresetowanie hasła.
        </p>
        <p>
          Sprawdź swoją skrzynkę pocztową, również folder spam. <br />
          Link będzie aktywny przez 24 godziny.
        </p>
        <v-btn
          :to="{ name: 'Login' }"
          title="Wróć na stronę logowania"
          rounded
          large
          color="primary"
          elevation="0"
          class="mt-4"
        >
          Wróć na stronę logowania
        </v-btn>
      </div>
      <div v-else>
        <h2 class="label mb-6">
          Wystarczy, że podasz swój e-mail, <br />a my pomożemy Ci ustawić nowe
          hasło.
        </h2>
        <v-form @submit.prevent autocomplete="off">
          <validation-observer ref="observer" v-slot="{}">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|email"
              name="e-mail"
            >
              <v-text-field
                v-model="email"
                label="E-mail"
                :error-messages="errors"
                required
                outlined
                persistent-placeholder
                :disabled="forgotPasswordDisabled"
                background-color="white"
                autocomplete="off"
              />
            </ValidationProvider>
          </validation-observer>

          <LoginAlerts
            :show="message.show"
            :type="message.color"
            :msg="message.msg"
            @close="message.show = false"
            dismissible
          />

          <div class="actions">
            <div class="actions_links">
              <LibBtnSimple
                color="primary"
                text="Wróć do logowania"
                rounded
                underline
                title="Wróć do logowania"
                :to="{ name: 'Login' }"
                class="mr-3"
              />
              <v-btn
                type="submit"
                title="Wyślij email"
                :class="{
                  'black--text': $vuetify.theme.dark,
                  'mt-1': true
                }"
                rounded
                large
                depressed
                color="primary"
                :disabled="forgotPasswordDisabled"
                :loading="loading"
                @click="forgotPassword"
              >
                Wyślij email
              </v-btn>
            </div>
          </div>
        </v-form>
      </div>
    </div>
  </div>
</template>
<script>
import LibBtnSimple from "@/components/library/common/LibBtnSimple.vue";
import LoginAlerts from "../components/LoginAlerts.vue";
import {
  ValidationObserver,
  ValidationProvider,
  setInteractionMode
} from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { extend } from "vee-validate";
setInteractionMode("lazy");
extend("required", required);
extend("email", {
  ...email,
  message: "Wprowadź poprawny adres e-mail"
});
import axios from "axios";

export default {
  name: "RemaindPassword",
  components: {
    ValidationProvider,
    ValidationObserver,
    LibBtnSimple,
    LoginAlerts
  },
  data() {
    return {
      email: null,
      forgotPasswordDisabled: false,
      loading: false,
      message: {
        timeout: 0,
        text: "",
        color: "error",
        show: false,
        closeAction: () => {}
      }
    };
  },
  computed: {
    showSuccessText() {
      return this.message.color === "success";
    }
  },
  methods: {
    forgotPassword() {
      this.forgotPasswordDisabled = true;
      this.loading = true;
      this.$refs.observer.validate().then((result) => {
        if (result === true) {
          axios
            .post(
              `${process.env.VUE_APP_AUTH_REST_URL}/password/notification`,
              { email: this.email }
            )
            .then(({ data }) => {
              if (data?.success === true) {
                this.message.msg =
                  "Na podany e-mail wysłano link resetujący hasło.";
                this.message.color = "success";
              } else {
                this.message.msg =
                  data?.errorMessage ||
                  "Nie odnaleziono konta użytkownika powiązanego z podanym adresem e-mail.";
                this.message.color = "error";
              }
              this.message.show = true;
            })
            .catch(() => {
              this.message.msg = "Błąd. Proszę spróbować poźniej.";
              this.message.timeout = 5000;
              this.message.color = "error";
              this.message.show = true;
              this.resetSnack();
              this.message.closeAction = () => {
                this.message.show = false;
              };
            })
            .finally(() => {
              this.forgotPasswordDisabled = false;
              this.loading = false;
            });
        } else {
          this.forgotPasswordDisabled = false;
          this.loading = false;
        }
      });
    },

    resetSnack() {
      setTimeout(() => {
        this.message.show = false;
      }, this.message.timeout + 1);
    }
  },
  metaInfo: {
    title: "Przypomnienie hasła"
  }
};
</script>
